import React from 'react';
import ProfileView from '../../components/ProfileView';
import { useCurrentUser } from '../../hooks/useCurrentUser';

export default function ProfilePage() {
  const { user } = useCurrentUser();

  if (!user) {
    return null;
  }

  return <ProfileView user={user} canLogout={true} />;
}
